import React from 'react';

import styled from 'styled-components';

interface StyledComponentProps {
    width?: number;
    height?: number;
  }

const Icon = ({icon, width = 20, height = 20}) => {

return(
  <Container width={width} height={height}>
    <img src={icon} />
  </Container>
)

}
export { Icon };

const Container = styled.div<StyledComponentProps>`
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        display: block;
        width:100%;
        height: 100%;
        object-fit: contain;
    }
`;